export const TYPE = {
    ALL: 'ALL',
    RENT: 'RENT',
    SELL: 'SELL'
};

export const STATUS = {
    DRAFT: 'DRAFT',
    DELETE: 'DELETE',
    ACTIVE: 'ACTIVE'
};

export const RANGE_TYPE = {
    OTHER: 'OTHER',
    EXCLUSIVE: 'EXCLUSIVE',
    SEMI_EXCLUSIVE: 'SEMI_EXCLUSIVE'
};

export const TYPE_RULE_RESERVATION = {
    SIMPLE: 'SIMPLE',
    STRONG: 'STRONG',
    FLEXIBLE: 'FLEXIBLE'
};

export const TYPE_APARTMENT = {
    WILLA: 'WILLA',
    FINCA: 'FINCA',
    NOINFO: 'NOINFO',
    APARTMENT: 'APARTMENT',
    TOWNHOUSE: 'TOWNHOUSE',
    LAND_PLOT: 'LAND_PLOT',
    COMMERCIAL: 'COMMERCIAL'
};

export const TYPE_TERM = {
    ALL: 'ALL',
    LONG: 'LONG',
    HOLIDAY: 'HOLIDAY'
};

export const SOURCE_TYPE = {
    USER: 'USER',
    RESALES: 'RESALES',
    ESCANDA: 'ESCANDA',
    MAHERSOL: 'MAHERSOL',
    PANORAMA: 'PANORAMA'
};

export const CURRENCY = {
        USD: {value: 'USD', mark: '$'},
        RUB: {value: 'RUB', mark: '₽'},
        EUR: {value: 'EUR', mark: '€'},
        AUD: {value: "AUD", mark: "A$"},
        CAD: {value: "CAD", mark: "С$"}
    }
;

export const EMBED = {
    USER: 'USER',
    IMAGES: 'IMAGES',
    TRANSLATES: 'TRANSLATES',
    GOOGLEADDRESS: 'GOOGLEADDRESS',
    EXTERNALCALENDARS: 'EXTERNALCALENDARS',
    EXPORT: 'EXPORT'
};

export const DATA_PAGE_EMBED = {
    OBJECT_ADDITIONAL_INFO: 'OBJECT_ADDITIONAL_INFO'
};

export const AMENITIES = {};

export const LIFESTYLE = {
    GOLF: 'GOLF',
    COUNTRY: 'COUNTRY',
    BEACHSIDE: 'BEACHSIDE'
};

export const POOL = {
    PRIVATE: 'PRIVATE',
    COMMUNAL: 'COMMUNAL'
};

export const GARAGE = {
    NONE: 'NONE',
    PRIVATE: 'PRIVATE',
    COMMUNAL: 'COMMUNAL',
    FREE_PARKING_IN_THE_STREET: 'FREE_PARKING_IN_THE_STREET'
};

export const GARDEN = {
    NONE: 'NONE',
    PRIVATE: 'PRIVATE',
    COMMUNAL: 'COMMUNAL'
};

export const FLOOR = {
    HIGH: 'HIGH',
    LOWER: 'LOWER',
    MIDDLE: 'MIDDLE',
    PENTHOUSE: 'PENTHOUSE'
};

export const ORIENTATION = {
    WEST: 'WEST',
    EAST: 'EAST',
    SOUTH: 'SOUTH',
    NORTH: 'NORTH'
};

export const VIEWS = {
    SEA: 'SEA',
    LAKE: 'LAKE',
    FOREST: 'FOREST',
    GARDEN: 'GARDEN',
    MOUNTAINS: 'MOUNTAINS',
    GOLF_COURSE: 'GOLF_COURSE'
};

export const CONDITION = {
    GOOD: 'GOOD',
    AVERAGE: 'AVERAGE',
    EXCELLENT: 'EXCELLENT',
    REQUIRES_REPAIR: 'REQUIRES_REPAIR'
};

export const KITCHEN = {
    MODERN: 'MODERN',
    CLASSICAL: 'CLASSICAL'
};

export const NEW_TYPE = {
    NEW: 'NEW',
    SECONDARY: 'SECONDARY'
};

export const FIELDS = {
    LAT: 'LAT',
    LNG: 'LNG',
    AREA: 'AREA',
    TYPE: 'TYPE',
    CITY: 'CITY',
    POOL: 'POOL',
    INDEX: 'INDEX',
    FLOOR: 'FLOOR',
    VIEWS: 'VIEWS',
    STATUS: 'STATUS',
    STREET: 'STREET',
    GARAGE: 'GARAGE',
    GARDEN: 'GARDEN',
    COUNTRY: 'COUNTRY',
    DEPOSIT: 'DEPOSIT',
    TERRACE: 'TERRACE',
    LICENSE: 'LICENSE',
    KITCHEN: 'KITCHEN',
    PROVINCE: 'PROVINCE',
    LOCATION: 'LOCATION',
    CLEANING: 'CLEANING',
    MIN_DAYS: 'MIN_DAYS',
    MAX_STAY: 'MAX_STAY',
    CHECK_IN_START_TIME: 'CHECK_IN_START_TIME',
    CHECK_IN_END_TIME: 'CHECK_IN_END_TIME',
    CHECK_OUT_TIME: 'CHECK_OUT_TIME',
    NEW_TYPE: 'NEW_TYPE',
    TYPE_TERM: 'TYPE_TERM',
    APARTMENT: 'APARTMENT',
    AMENITIES: 'AMENITIES',
    LIFESTYLE: 'LIFESTYLE',
    CONDITION: 'CONDITION',
    COUNT_BEDS: 'COUNT_BEDS',
    PRICE_SELL: 'PRICE_SELL',
    CURRENCY: 'CURRENCY',
    FIX_MARKER: 'FIX_MARKER',
    RANGE_TYPE: 'RANGE_TYPE',
    COUNT_GUEST: 'COUNT_GUEST',
    DESCRIPTION: 'DESCRIPTION',
    LANGUAGE_CODE: 'LANGUAGE_CODE',
    EXCESS_FARE: 'EXCESS_FARE',
    ORIENTATION: 'ORIENTATION',
    URL_EXTERNAL: 'URL_EXTERNAL',
    DISPLAY_NAME: 'DISPLAY_NAME',
    RENT_COMMENT: 'RENT_COMMENT',
    AUTOCOMPLETE: 'AUTOCOMPLETE',
    STREET_NUMBER: 'STREET_NUMBER',
    TYPE_APARTMENT: 'TYPE_APARTMENT',
    COUNT_BEDROOMS: 'COUNT_BEDROOMS',
    COUNT_BATHROOM: 'COUNT_BATHROOM',
    PRICE_RENT_LONG: 'PRICE_RENT_LONG',
    PRICE_RENT_BASE: 'PRICE_RENT_BASE',
    YEAR_OF_CONSTRUCTION: 'YEAR_OF_CONSTRUCTION',
    TYPE_RULE_RESERVATION: 'TYPE_RULE_RESERVATION'
};

export const OBJECT_REPRESENT_FIELDS = {
    TYPE: {parent: 'props', value: 'type'},
    AREA: {parent: 'props', value: 'area'},
    VIEWS: {parent: 'other', value: 'views'},
    STATUS: {parent: 'props', value: 'status'},
    LAT: {parent: 'location', value: 'latitude'},
    CITY: {parent: 'userAddress', value: 'city'},
    TERRACE: {parent: 'props', value: 'terrace'},
    LICENSE: {parent: 'props', value: 'license'},
    DEPOSIT: {parent: 'price', value: 'deposit'},
    KITCHEN: {parent: 'other', value: 'kitchen'},
    LNG: {parent: 'location', value: 'longitude'},
    MIN_DAYS: {parent: 'price', value: 'minDays'},
    MAX_STAY: {parent: 'price', value: 'maxStay'},

    CHECK_IN_START_TIME: {parent: 'props', value: 'checkInStartTime'},
    CHECK_IN_END_TIME: {parent: 'props', value: 'checkInEndTime'},
    CHECK_OUT_TIME: {parent: 'props', value: 'checkOutTime'},

    NEW_TYPE: {parent: 'other', value: 'newType'},
    INDEX: {parent: 'userAddress', value: 'index'},
    CLEANING: {parent: 'price', value: 'cleaning'},
    TYPE_TERM: {parent: 'props', value: 'typeTerm'},
    POOL: {parent: 'characteristics', value: 'pool'},
    STREET: {parent: 'userAddress', value: 'street'},
    CONDITION: {parent: 'other', value: 'condition'},
    COUNT_BEDS: {parent: 'props', value: 'countBeds'},
    PRICE_SELL: {parent: 'price', value: 'priceSell'},
    RANGE_TYPE: {parent: 'props', value: 'rangeType'},
    FLOOR: {parent: 'characteristics', value: 'floor'},
    COUNTRY: {parent: 'userAddress', value: 'country'},
    COUNT_GUEST: {parent: 'props', value: 'countGuest'},
    EXCESS_FARE: {parent: 'price', value: 'excessFare'},
    GARAGE: {parent: 'characteristics', value: 'garage'},
    GARDEN: {parent: 'characteristics', value: 'garden'},
    ORIENTATION: {parent: 'other', value: 'orientation'},
    PROVINCE: {parent: 'userAddress', value: 'province'},
    FIX_MARKER: {parent: 'location', value: 'fixMarker'},
    APARTMENT: {parent: 'userAddress', value: 'apartment'},
    TYPE_APARTMENT: {parent: 'props', value: 'typeApartment'},
    COUNT_BEDROOMS: {parent: 'props', value: 'countBedrooms'},
    LIFESTYLE: {parent: 'characteristics', value: 'lifestyle'},
    DESCRIPTION: {parent: 'description', value: 'description'},
    LANGUAGE_CODE: {parent: 'description', value: 'languageCode'},
    STREET_NUMBER: {parent: 'userAddress', value: 'streetNum'},
    COUNT_BATHROOM: {parent: 'props', value: 'countBathrooms'},
    PRICE_RENT_LONG: {parent: 'price', value: 'priceRentLong'},
    PRICE_RENT_BASE: {parent: 'price', value: 'priceRentBase'},
    CURRENCY: {parent: 'price', value: 'currency'},
    DISPLAY_NAME: {parent: 'description', value: 'displayName'},
    RENT_COMMENT: {parent: 'description', value: 'rentComment'},
    AUTOCOMPLETE: {parent: 'userAddress', value: 'autocomplete'},
    TYPE_RULE_RESERVATION: {parent: 'props', value: 'cancellationRule'},
    YEAR_OF_CONSTRUCTION: {parent: 'characteristics', value: 'yearOfConstruction'},
    AMENITIES: {parent: null, value: 'amenities'},
};



// WEBPACK FOOTER //
// ./src/constants/Property.js